import _ from "lodash";
import { DeploymentMode } from "../app-config";
import { CloudBackendTier } from "./auth";

export const DEPLOYMENT_CONFIGURATION_FILE_NAME = './config.json';

/**
 * Deployment configuration file. Is placed into a Config UI deployment and is used to configure particulars of that deployment.
 * File is read upon app initialization and is used to set up some fundamental app configurations.
 */
export type DeploymentConfigInfo = {
    /** Deployment mode of this app deployment/installation. */
    deploymentMode: DeploymentMode,
    /** The URL in which a cloud backend is located. Not used in local mode. */
    cloudBackendUrl?: string;
    /** The tier of the cloud backend.  Not used in local mode. */
    cloudBackendTier?: CloudBackendTier;
    /** URL linking to a dashboard deployment. */
    dashboardUrl?: string;
    /** Optional name for the backend. Not used in UI as the app doesn't currently support multiple backends. Not used in local mode. */
    backendName?: string;
    /** Link to a ROI customization operations manual. */
    operationsManualUrl?: string;
    /** Omit any localizations from UI that match these lang keys (e.g.: ['en-US', 'fr-FR', 'pseudo']) */
    omitLocalizationsFromUi?: string[];
    /** Daemon config page can optionally be disabled altogether. */
    disableDaemonConfigPage: boolean;
}


export const generateDeploymentConfigInfo = (jsonObject: any): DeploymentConfigInfo | undefined => {
    if ('deploymentMode' in jsonObject && Object.values(DeploymentMode).includes(jsonObject['deploymentMode'])) {

        const deploymentConfigInfo: DeploymentConfigInfo = {
            deploymentMode: jsonObject['deploymentMode'],
            disableDaemonConfigPage: false,
        }

        if ('cloudBackendUrl' in jsonObject) {
            deploymentConfigInfo.cloudBackendUrl = jsonObject['cloudBackendUrl'];
        }
        if ('cloudBackendTier' in jsonObject && Object.values(CloudBackendTier).includes(jsonObject['cloudBackendTier'])) {
            deploymentConfigInfo.cloudBackendTier = jsonObject['cloudBackendTier'];
        }
        if ('dashboardUrl' in jsonObject) {
            deploymentConfigInfo.dashboardUrl = jsonObject['dashboardUrl'];
        }
        if ('backendName' in jsonObject) {
            deploymentConfigInfo.backendName = jsonObject['backendName'];
        }
        if ('operationsManualUrl' in jsonObject) {
            deploymentConfigInfo.operationsManualUrl = jsonObject['operationsManualUrl'];
        }
        if ('omitLocalizationsFromUi' in jsonObject) {
            deploymentConfigInfo.omitLocalizationsFromUi = jsonObject['omitLocalizationsFromUi'];
        }
        if ('disableDaemonConfigPage' in jsonObject) {
            // although daemon config page is NOT disabled by default, in an unclear situation it will get disabled
            deploymentConfigInfo.disableDaemonConfigPage = _.isBoolean(jsonObject['disableDaemonConfigPage']) ? jsonObject['disableDaemonConfigPage'] : true;
        }

        return deploymentConfigInfo;
    }

    return undefined;
}
